import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const Four0Four = () => {
    return (
        <Layout>
            <section className="page-hero" style={{ minHeight: "50vh", display: "flex", alignItems: "center" }}>
                <div className="container" style={{ textAlign: "center" }}>
                    <h1>Page not found</h1>
                    <p>The page you're looking for doesn't exist or has been moved.</p>
                    <div className="actions" style={{ justifyContent: "center", marginTop: 24 }}>
                        <Link className="btn btn-primary" to="/">Back to home</Link>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default Four0Four;
